import { createFileRoute } from "@tanstack/react-router";
import SeoInspector from "@/pages/admin/SeoInspector";

export const Route = createFileRoute("/admin/seo-inspector")({
  component: SeoInspector,
});
